






















import { Component, Vue, PropSync } from "vue-property-decorator";

@Component
class WithdrawAuditModal extends Vue {
  @PropSync("visible") bindVisible!: boolean;

  traceId = "";

  loading = false;

  handleCancle() {
    this.bindVisible = false;
  }

  async handleViewTransaction() {
    this.loading = true;
    try {
      const transaction = await this.$api.defi.getTransactionByTraceId(
        this.traceId
      );
      this.toTransaction(transaction.id);
    } catch (error) {
      console.log(error);
    }
    this.loading = false;
  }

  toTransaction(id) {
    this.$helper.toFusionPath(this, "defi", {
      name: "transactions-id",
      params: { id }
    });
  }

  show(traceId) {
    this.bindVisible = true;
    this.traceId = traceId;
  }
}
export default WithdrawAuditModal;
